export class User {
    isUnchecked: boolean = false;
    email: string = '';
    roles: string = '';
    expiry?: number;

    constructor(userObj: object) {
        userObj && Object.assign(this, userObj);
    }

    hasRole(role: string) {
        return this.roles.split(' ').indexOf(role) >= 0;
    }

    isAnon() {
        return !this.email;
    }

    static AnonUser() {
        return new User({ email: '', roles: '' });
    }

    static UncheckedUser() {
        return new User({ email: '', roles: '', isUnchecked: true });
    }
}